module.exports = __webpack_public_path__ + "img/flags/LV.7ceac79.png";